import { h, Component } from "preact";
import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import actions from "../../actions";
import FormattedDate from "../../../common/components/FormattedDate";
import { PERIOD_TYPE_VALUES } from "../../constants";
import EventRowDataDesktop from "./EventRowDataDesktop";
import EventRowDataMobile from "./EventRowDataMobile";
import { isMobileOnly } from "react-device-detect";
import { PureComponent } from "preact/compat";

class EventRowData extends PureComponent {
    constructor(props) {
        super(props);

        this.showDetails = this.showDetails.bind(this);
        this.showMinimalDetails = this.showMinimalDetails.bind(this);
        this.fetchDetails = this.fetchDetails.bind(this);
        this.renderName = this.renderName.bind(this);
    }

    fetchDetails() {
        const {
            event: { id },
            fetchEventDateDetails,
        } = this.props;

        fetchEventDateDetails(id);
    }

    renderName(eventDate) {
        let result = <span>{eventDate.name}</span>;
        if (eventDate.periodType && eventDate.periodDateUtc) {
            let periodText = "";
            const translationKey = PERIOD_TYPE_VALUES[eventDate.periodType];
            switch (eventDate.periodType) {
                case "DAY":
					break;
                case "MONTH":
                    if (translationKey) {
                        const format = this.props.translate(translationKey);
                        periodText = (
                            <FormattedDate
                                date={eventDate.periodDateUtc}
                                format={format}
                            />
                        );
                    }
                    break;
                case "QUARTER":
                    const quarterNumber =
                        Math.floor(eventDate.periodDateUtc.getMonth() / 3) + 1;
                    periodText = this.props.translate("Period_QuarterFormat", [
                        quarterNumber,
                    ]);
                    break;
                default:
                    break;
            }

            if (periodText && periodText !== "") {
                result = (
                    <span>
                        <span>{eventDate.name}</span>
                        <span> (</span>
                        <span>{periodText}</span>
                        <span>)</span>
                    </span>
                );
            }
        }

        return result;
    }

    showDetails() {
        const {
            event: { id },
            showEventDateDetails,
        } = this.props;
        showEventDateDetails(id);
        this.fetchDetails();
    }

    showMinimalDetails() {
        const {
            event: { id },
            showEventDateMinimalDetails,
        } = this.props;
        showEventDateMinimalDetails(id);
        this.fetchDetails();
    }

    render({ event, onClickDetails, isSubscribed, canBeSubscribed }) {
        const click = onClickDetails || this.showDetails;
        const clickMinimal = onClickDetails || this.showMinimalDetails;

        return isMobileOnly ? (
            <EventRowDataMobile
                event={event}
                canBeSubscribed={canBeSubscribed}
                isSubscribed={isSubscribed}
                showDetailsClick={clickMinimal}
                renderName={this.renderName}
            />
        ) : (
            <EventRowDataDesktop
                event={event}
                canBeSubscribed={canBeSubscribed}
                isSubscribed={isSubscribed}
                showDetailsClick={click}
                renderName={this.renderName}
            />
        );
    }
}

export default connectWithTranslations("settings,config", actions)(EventRowData);
